import { axiosPost } from '../ServiceBase';

export const getSolicitudCobertura = async (data) => {
  const response = await axiosPost('/v1/busquedas/solicitudes-cobertura-tablero', data);
  return response;
};

export const getSolicitudCoberturaIniciadosAutorizados = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/solicitudes-cobertura-tablero/iniciados-autorizados',
    data,
  );
  return response;
};

export const getSolicitudCoberturaTramitesPorDelegacion = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/solicitudes-cobertura-tablero/tramites-por-delegacion',
    data,
  );
  return response;
};

export const getSolicitudCoberturaTramitesPorAuditor = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/solicitudes-cobertura-tablero/tramites-por-usuario',
    data,
  );
  return response;
};
